import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/deviceLogs';
import moment from 'moment-timezone';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import formSelectors from 'selectors/form';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const INTERVENTION_TYPES = {
    'Preventive Maintenance': '[DURATION] \n[DESCRIPTION] ',
    'Corrective Maintenance': '[DURATION] \n[DESCRIPTION] ',
    'Work Order': '[DURATION] \n[DESCRIPTION] ',
    'Commissioning': ''
};

const DEFAULT_COMMISSIONING = '[TI MAX CURRENT] A\n[TI TYPE] MONOPHASE / TRIPHASE\n[METER L1] A\n[METER L2] A\n[METER L3] A\n[METER PFT] \n[CLAMP L1] A\n[CLAMP L2] A\n[CLAMP L3] A';
const WISE_BOX_COMMISSIONING = '[Modbus] OK / NOTOK\n[OneWire] OK / NOTOK\n[WiseOutput 1] OK / NOTOK\n[WiseOutput 2] OK / NOTOK\n';

const Component = props => {
    const { device } = props;
    const { onSave } = props;

    const currentUser = useSelector(state => state.users.models[state.auth.currentUserId]);
    const formValues = useSelector(state => formSelectors.getFormValues(state));
    const loading = useSelector(state => state.deviceLogs.loading);

    const dispatch = useDispatch();

    const formSchema = [
        {
            label: 'Intervention Date\x2a',
            name: 'intervention_at',
            transformation: value => moment(value, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DD HH:mm:ss'),
            type: 'dateTime',
            validate: [validators.required]
        },
        {
            disabled: !!formValues.description,
            formData: Object.keys(INTERVENTION_TYPES).map(it => ({ id: it, name: it })),
            label: 'Type*',
            name: 'type',
            type: 'select',
            validate: [validators.required]
        },
        {
            disabled: !formValues.type,
            label: 'Description\x2a',
            name: 'description',
            validate: [validators.required],
            rows: 16,
            type: 'textArea'
        }
    ];

    const create = actions.create;
    const onSubmit = values => {
        let description = values.description;

        if (!description || !description.trim()) {
            description = `[TYPE] ${values.type}\n`;
            description += `[USER] ${currentUser.name}\n`;
            description += (INTERVENTION_TYPES[values.type] || '');

            if (values.type === 'Commissioning') {
                description += device.old_wise_box ? WISE_BOX_COMMISSIONING : DEFAULT_COMMISSIONING;
            }
        }

        const data = {
            ...serializeForm({ ...values, description }, formSchema),
            device_id: device.id,
            type: 'intervention'
        };

        dispatch(create(data, () => onSave()));
    };

    const [formInitialValues] = useState(() => ({
        description: '',
        intervention_at: moment().format('YYYY-MM-DDTHH:mm')
    }));

    return (
        <FormViewer label={'Add Intervention Form'}>
            <Form
                formInitialValues={formInitialValues}
                formSchema={formSchema}
                isSubmitting={loading}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
